/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import StudyInformation from './study.information.component';
import {
  fetchExportArchiveStatus,
  fetchSignedConsentingsNumber,
  fetchStudyInformation,
  selectTenantAndSetCookie
} from '../../../actions/actions';
import { withRouter } from 'react-router-dom';

export const mapStateToProps = (state, ownProps) => {
  return {
    studyGid: ownProps.studyGid,
    isFetching: state.subject.isFetchingStudy || state.reports.isFetching,
    error: state.subject.error || state.reports.error,
    study: state.subject.participantStudy,
    user: state.login.user,
    sponsor: state.sponsor,
    productionTenantForUAT: state.subject.productionTenantForUAT,
    hasNewDataAvailable: state.reports.newDataAvailableForExport,
    signedConsentingsNo: state.study.signedConsentingsNo
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  const { history } = ownProps;
  return {
    loadData: (studyGid) => {
      dispatch(fetchStudyInformation(studyGid));
    },
    navigateToTenant: (tenant) => {
      dispatch(selectTenantAndSetCookie(tenant, history));
    },
    getSignedConsentingsNumber: (studyGid) => {
      dispatch(fetchSignedConsentingsNumber(studyGid));
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StudyInformation));
